import React from "react";

const LockIcon = ({ color = "black" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00098 8.50007V5.5002C6.00098 4.43937 6.42238 3.422 7.17249 2.67189C7.92261 1.92178 8.93997 1.50037 10.0008 1.50037C11.0616 1.50037 12.079 1.92178 12.8291 2.67189C13.5792 3.422 14.0006 4.43937 14.0006 5.5002V8.50007"
        stroke={color}
        stroke-linecap="round"
      />
      <path
        d="M3.00098 8.5H17.0003V17.4996C17.0003 18.03 16.7896 18.5387 16.4146 18.9138C16.0395 19.2888 15.5308 19.4995 15.0004 19.4995H5.00088C4.47048 19.4995 3.96179 19.2888 3.58674 18.9138C3.21168 18.5387 3.00098 18.03 3.00098 17.4996V8.5Z"
        stroke={color}
        stroke-linejoin="round"
      />
      <path
        d="M12.501 13.9999H12.5115V14.0104H12.501V13.9999Z"
        stroke={color}
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default LockIcon;
